<template>
  <div class="wrapper">
    <div class="shop-container">
      <div class="nav">
        <router-link to="home">首页</router-link>
        <span>></span>
        <span>文章中心</span>
      </div>
      <div class="main">
        <div class="l bgw">
          <div class="list-wrap" v-for="(item,index) in list" :key="index">
            <h3 class="title">{{item.type_name}}</h3>
            <ul>
              <li v-for="(nav,i) in item.child" :key="i" :class="{'active':artClassId==nav.id}">
                <a href="javascript:;" @click="lookType(nav)">{{nav.type_name}}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="r">
          <div class="bgw">
            <template v-if="showDetail">
              <div class="article-nav">
                <div v-for="item in detail.article_type">
                  <div v-for="father in item.father">
                    <span class="artlink">{{father.type_name}}</span> >
                    <a
                      href="javascript:;"
                      class="artlink"
                      @click="getArticleList(item.id)"
                    >{{item.type_name}}</a>
                  </div>
                </div>
              </div>
              <div class="top-head">{{detail.title}}</div>
              <template>
                <div v-html="detail.content"></div>
              </template>
            </template>
            <template v-else>
              <ul class="art-list">
                <li v-for="(item,index) in articleList" :key="index">
                  <a href="javascript:;" @click="getArticleDetail(item.id)">
                    <span>·&nbsp;{{item.title}}</span>
                    <span>{{newTime(item.ctime)}}</span>
                  </a>
                </li>
              </ul>
              <Pagination
                :totalPage="totalPage"
                :limit="limit"
                @changePage="handOrderMore"
                v-if="totalPage>1"
              ></Pagination>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";
import { timeToDate } from "@/utils";
export default {
  name: "Center",
  components: { Pagination },
  props: {},
  data() {
    return {
      list: [],
      page: 1,
      limit: 10,
      articleList: [],
      detail: {},
      totalPage: 0,
      showDetail: false,
      artClassId:''
    };
  },
  watch: {},
  computed: {
    newTime() {
      return time => {
        return timeToDate(time);
      };
    }
  },
  methods: {
    lookType(nav) {
      this.artClassId = nav.id;
      this.getArticleList(nav.id);
    },
    handOrderMore(val) {
      this.page == val;
      this.getArticleList();
    },
    //获取分类列表
    getArticleList(id) {
      let data = {
        type_id: id || this.artClassId,
        page: this.page,
        limit: this.limit
      };
      this.$api.articleList(data).then(res => {
        if (res.status) {
          this.articleList = res.data.list;
          this.totalPage = Math.ceil(
            Number(res.data.count) / Number(this.limit)
          );
          this.showDetail = false;
        }
      });
    },
    //获取文章详情
    getArticleDetail(id) {
      let data = {
        article_id: id
      };
      this.$api.articleInfo(data).then(res => {
        if (res.status) {
          this.detail = res.data;
          this.artClassId = res.data.article_type[0].id;
          this.showDetail = true;
        } else {
          this.$msg(res.msg, "error");
        }
      });
    },
    getArticleNav() {
      this.$api.articleTypeList().then(res => {
        if (res.status) {
          this.list = res.data.list;
        }
      });
    }
  },
  created() {},
  mounted() {
    let query = this.$route.query;
    if (query.type == 2) {
      this.artClassId = query.id;
      this.getArticleList(query.id);
    } else {
      this.getArticleDetail(query.id);
    }
    this.getArticleNav();
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.wrapper {
  .nav {
    @include line-height(40px);
    font-size: 12px;
    span {
      padding: 0 4px;
      font-size: #757575;
    }
    a:hover {
      color: #000;
    }
  }
  .main {
    display: flex;
    margin-bottom: 20px;
    .l {
      width: 234px;
      margin-right: 20px;
      padding: 40px 0;
      .list-wrap {
        margin-bottom: 20px;
        .title {
          padding-left: 48px;
          height: 40px;
          line-height: 40px;
          font-size: 16px;
          color: #333;
        }
        ul {
          li {
            padding-left: 48px;
            height: 32px;
            line-height: 32px;
            color: #757575;
            &.active {
              color: $theme-color;
            }
            a:hover {
              color: $theme-color;
            }
            a.router-link-active {
              color: $theme-color;
            }
          }
        }
      }
    }
    .r {
      flex: 1;
      .bgw {
        padding: 24px;
        min-height: 600px;
        .article-nav {
          height: 30px;
          line-height: 30px;
          border-bottom: 1px dashed $border;
          margin-bottom: 20px;
          a.artlink {
            &:hover {
              color: $theme-color;
            }
          }
        }
        .top-head {
          font-size: 24px;
          font-weight: 400;
          line-height: 40px;
          color: #757575;
          margin-bottom: 10px;
        }
      }
      .art-list {
        li {
          a {
            display: block;
            display: flex;
            justify-content: space-between;
            border-bottom: 1px dashed $border;
            height: 30px;
            line-height: 30px;
            padding-left: 10px;
            position: relative;
            &:hover {
              color: $theme-color;
            }
          }
        }
      }
    }
  }
}
</style>
